import React from 'react';
import { Share2 } from 'lucide-react';
import { WhatsAppIcon } from './BrandIcons';

// Shown after a successful conversion. Shares the TOOL, never the file —
// converted files are private and deleted within 2 hours, so there's
// nothing to actually share; this is a growth loop, not a file-sharing
// feature. Keeps it that way deliberately.
const SITE_URL = 'https://iloveconvert.in';

export default function ShareButtons({ toolLabel }) {
  const text = toolLabel
    ? `I just used ILoveConvert's ${toolLabel} tool — free, no signup needed. Try it: ${SITE_URL}`
    : `I just converted my file for free using ILoveConvert — no signup needed. Try it: ${SITE_URL}`;

  const whatsappHref = `https://wa.me/?text=${encodeURIComponent(text)}`;
  const canNativeShare = typeof navigator !== 'undefined' && !!navigator.share;

  const handleNativeShare = async () => {
    try {
      await navigator.share({ title: 'ILoveConvert', text, url: SITE_URL });
    } catch (e) {
      // User cancelled the share sheet — not an error, nothing to do.
    }
  };

  return (
    <div style={{ marginTop: 14, paddingTop: 14, borderTop: '1px dashed var(--border)' }}>
      <p style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginBottom: 8 }}>Found this useful? Share it:</p>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
        <a
          href={whatsappHref}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-outline btn-sm"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
        >
          <WhatsAppIcon size={15} /> WhatsApp
        </a>
        {canNativeShare && (
          <button
            onClick={handleNativeShare}
            className="btn btn-outline btn-sm"
            style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
          >
            <Share2 size={15} /> Share
          </button>
        )}
      </div>
    </div>
  );
}
